<template>
  <div class="nav-bar">
    <div class="nav-box1"></div>

    <div class="nav-box">
      <div class="nav-left">
        <a href="#">
          <img v-if="isEnglish" @click="goto_leader" src="../assets/logo.png" alt="">
          <img v-else @click="goto_leader" src="../assets/logo.jpg" alt="">
        </a>
      </div>
      <div class="nav-right">
        <div v-if="isMobile" class="mobile-toggle" @click="showMobileDropdown = !showMobileDropdown"
          ref="mobileDropdownRef">
          ☰
        </div>
        <div v-if="isMobile && showMobileDropdown" class="mobile-dropdown">
          <ul>
            <li @click="goto_leader">{{ isEnglish ? 'Home' : '首页' }}</li>
            <li @click="goto_product">{{ isEnglish ? 'Products & Solutions' : '产品与解决方案' }}</li>
            <li @click="goto_producthard" v-if="!isEnglish">{{ isEnglish ? 'Hardware Product' : '硬件产品' }}</li>
            <li @click="goto_case">{{ isEnglish ? 'Industry Case' : '行业案例' }}</li>
            <li @click="goto_news">{{ isEnglish ? 'News' : '新闻' }}</li>
            <li @click="goto_about">{{ isEnglish ? 'About Us' : '关于我们' }}</li>
          </ul>
        </div>
        <div v-else class="right-content">
          <ul>
            <li @click="goto_leader" :class="{ active: activeRoute === '/leader' }">{{ isEnglish ? 'Home' : '首页' }}</li>

            <li @mouseenter="showProduct = true" @mouseleave="showProduct = false" @click="goto_product"
              :class="{ active: activeRoute === '/producer' }">
              {{ isEnglish ? 'Products & Solutions' : '产品与解决方案' }}
              <transition name="slide-dropdown">
                <div class="dropdown dropdown_en" v-if="showProduct">

                  <div class="drop_left drop_left_en">
                    <h3>{{ isEnglish ? 'Software Products' : '软件产品' }}</h3>
                    <ul>
                      <li v-for="item in pro_data" :key="item.id" @click.stop="goto_system(item.id)">
                        <span>{{ item.name }}</span>
                      </li>
                    </ul>
                  </div>

                  <!-- 新增：硬件产品列 -->
                  <!-- <div class="drop_mid" v-if="!isEnglish">
                    <h3>{{ isEnglish ? 'Hardware Products' : '硬件产品' }}</h3>

                    <ul>
                      <li v-for="item in pro_hard_data" :key="item.id" @click.stop="goto_productharddetail(item.id)">
                        <span>{{ item.name }}</span>
                      </li>
                    </ul>
                  </div> -->

                  <div class="drop_right drop_right_en">
                    <h3>{{ isEnglish ? 'Solutions' : '解决方案' }}</h3>

                    <ul class="first-list">
                      <li v-for="item in sul_data" :key="item.id" @click.stop="goto_solution(item.id)">
                        <span>{{ item.name }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </transition>
            </li>
            <li @mouseenter="openHardwareDropdown" @mouseleave="scheduleHideHardware" @click="goto_producthard"  v-if="!isEnglish" :class="{ active: activeRoute === '/producthard' }">{{ isEnglish ? 'Hardware Product' : '硬件产品' }}
              <transition name="slide-dropdown">
                <div class="dropdown2" :class="{ 'has-devices': activeHardwareType && hardwareDevices[activeHardwareType]?.length }" v-if="showHardware"
                  @mouseenter="cancelHideHardware"
                  @mouseleave="scheduleHideHardware">

                  <div class="drop_left drop_left_en">
                    <h3>{{ isEnglish ? 'Hardware Products' : '硬件类型' }}</h3>
                    <ul>
                      <li v-for="item in hardware_data" :key="item.id"
                        @mouseenter="hoverHardwareType(item.id)"
                        @click.stop="goto_productharddetail(item.id)"
                        :class="{ 'active-type': activeHardwareType === item.id }">
                        <span>{{ item.name }}</span>
                      </li>
                    </ul>
                  </div>

                  <div class="drop_right drop_right_en" v-if="activeHardwareType && hardwareDevices[activeHardwareType]?.length">
                    <h3>设备列表</h3>
                    <ul>
                      <li v-for="device in hardwareDevices[activeHardwareType]" :key="device.id"
                        @click.stop="goto_hardware_detail(device.id)">
                        <span>{{ device.name }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </transition>
            </li>
            <li @click="goto_case" @mouseenter="showCase = true" @mouseleave="showCase = false"
              :class="{ active: activeRoute === '/case' }">
              {{ isEnglish ? 'Industry Case' : '行业案例' }}

              <!-- <transition name="slide-dropdown">
              <div class="dropdown"  v-if="showCase">
                <ul>
                  <li @click.stop="goto_ai">AI Platform</li>
                  <li @click.stop="goto_bigdata">Big Data</li>
                  <li @click.stop="goto_manage">Management</li>
                  <li @click.stop="goto_system">System Integration</li>
                  
                </ul>
              </div>
              </transition> -->
            </li>
            <li @click="goto_news" :class="{ active: activeRoute === '/news' }">{{ isEnglish ? 'News' : '新闻' }}</li>
            <li @click="goto_about" :class="{ active: activeRoute === '/about' }">{{ isEnglish ? 'About Us' : '关于我们' }}</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="nav-phone">
      <svg class="phone-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" stroke="#005BAC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span class="phone-number">400-009-1897</span>
    </div>
    <div class="nav-box1 nav-box2">
      <el-dropdown class="nav-dropdown" @command="handleCommand" v-if="showLanguageDropdown">

        <span class="el-dropdown-link">
          <svg class="span1" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="8" cy="8" r="7.25" stroke="#00000A" stroke-width="1.5" />
            <path
              d="M8 15.25C7.7649 15.25 7.48181 15.1442 7.15894 14.8321C6.83246 14.5165 6.50419 14.0235 6.21224 13.3562C5.62932 12.0239 5.25 10.1307 5.25 8C5.25 5.86928 5.62932 3.97615 6.21224 2.64376C6.50419 1.97645 6.83246 1.48352 7.15894 1.16789C7.48181 0.855751 7.7649 0.75 8 0.75C8.2351 0.75 8.51819 0.855751 8.84106 1.16789C9.16754 1.48352 9.49581 1.97645 9.78776 2.64376C10.3707 3.97615 10.75 5.86928 10.75 8C10.75 10.1307 10.3707 12.0239 9.78776 13.3562C9.49581 14.0235 9.16754 14.5165 8.84106 14.8321C8.51819 15.1442 8.2351 15.25 8 15.25Z"
              stroke="#00000A" stroke-width="1.5" />
            <line x1="1" y1="5.75" x2="15" y2="5.75" stroke="#00000A" stroke-width="1.5" />
            <line x1="1" y1="10.25" x2="15" y2="10.25" stroke="#00000A" stroke-width="1.5" />
          </svg>
<!--          <span class="span2">{{ getLanguage() }}/Language</span>-->
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item command="en">Engilsh</el-dropdown-item>
            <el-dropdown-item command="zh">中文</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
      <!-- <el-dialog 
  class="vidaodialog" 
  v-model="dialogFormVisible" 
  :width="isMobile ? '95%' : '60%'"
  :show-close="false"

  destroy-on-close>
  
  <div style="width: 100%; height: 100%;">
    <video 
      v-if="isEnglish" 
      style="width: 100%; height: 100%; object-fit: cover;" 
      src="https://official-web-static.womucloud.com/company_intro_en.mp4" 
      controls 
      muted 
      autoplay 
      loop>
    </video>
    <video 
      v-else 
      style="width: 100%; height: 100%; object-fit: cover;" 
      src="https://official-web-static.womucloud.com/company_intro_zh.mp4" 
      controls 
      muted 
      autoplay 
      loop>
    </video>
  </div>
  
  <template #footer>
    <div class="dialog-footer">
      
  <button class="close-btn" @click="dialogFormVisible = false" aria-label="关闭">
    <span class="close-icon">×</span>
  </button>
    </div>
  </template>
</el-dialog> -->
      <!-- <span class="span1" mask="https://developer.mozilla.org/static/media/language.e4289910782fa8d1c882.svg"></span> -->
    </div>
  </div>
</template>

<script setup name="NavigationBar">
import { ref, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { computed } from 'vue'
import { getSolutionList } from '../api/solution'
import { getProductList } from '../api/product'
import { getDeviceTypeList } from '../api/deviceType'
import { getDeviceList } from '../api/device'
import { onMounted, onUnmounted } from 'vue'
import { onClickOutside } from '@vueuse/core'

onMounted(() => {
  checkMobile()
  window.addEventListener('resize', checkMobile)
  navrender()
  dialogFormVisible.value = true
})
onUnmounted(() => {
  window.removeEventListener('resize', checkMobile)
})
const dialogFormVisible = ref(false)

const pro_data = ref([]);
const sul_data = ref([]);
// 新增：硬件产品数据
const pro_hard_data = ref([]);
const hardware_data = ref([]);
const hardwareDevices = ref({})
const activeHardwareType = ref(null)

async function fetchHardwareDevices(typeId) {
  if (hardwareDevices.value[typeId]) return
  const appId = window.location.pathname.startsWith('/en') ? 2 : 1
  const res = await getDeviceList({ appId, deviceTypeId: typeId, current: 1, size: 50 })
  hardwareDevices.value[typeId] = (res.data || []).slice(0, 6)
}

function hoverHardwareType(typeId) {
  activeHardwareType.value = typeId
  if (typeId) {
    fetchHardwareDevices(typeId)
  }
}

function goto_hardware_detail(id) {
  if (window.location.pathname.startsWith('/en')) {
    router.push(`/en/productharddetail?id=${id}`)
  } else {
    router.push(`/productharddetail?id=${id}`)
  }
}

let hardwareHideTimer = null
function openHardwareDropdown() {
  clearTimeout(hardwareHideTimer)
  showHardware.value = true
}
function scheduleHideHardware() {
  hardwareHideTimer = setTimeout(() => {
    showHardware.value = false
    activeHardwareType.value = null
  }, 150)
}
function cancelHideHardware() {
  clearTimeout(hardwareHideTimer)
}

const router = useRouter()
const route = useRoute()
const showProduct = ref(false)
const showHardware = ref(false)
const showCase = ref(false)
// 计算当前激活的路由
const activeRoute = computed(() => route.path)
// 页面缩小，适应布局
const isMobile = ref(false)
const showMobileDropdown = ref(false)
const mobileDropdownRef = ref(null)
const checkMobile = () => {
  isMobile.value = window.innerWidth <= 1024
}
const isEnglish = computed(() => {
  return window.location.pathname.startsWith('/en')
})
// 新增：控制语言切换下拉菜单显示的计算属性
// 新增：使用 watch 控制语言切换下拉菜单显示
const showLanguageDropdown = ref(false)

// 定义需要显示语言切换的页面路径
const allowedPaths = [
  '/', '/en',
  '/producer', '/en/producer',
  '/producthard', '/en/producthard',
  '/case', '/en/case',
  '/news', '/en/news',
  '/about', '/en/about'
]

// 监听路由变化，更新语言切换下拉菜单显示状态
watch(() => route.path, (newPath) => {
  showLanguageDropdown.value = allowedPaths.includes(newPath)
}, { immediate: true })

//点击外部下拉菜单也回收
onClickOutside(mobileDropdownRef, () => {
  showMobileDropdown.value = false
})
//点击图片跳转回首页
function goto_leader() {
  if (window.location.pathname.startsWith('/en')) {
    router.push('/en')
  } else {
    router.push('/')

  }
}
// 产品中心以及子跳转
function goto_product() {
  if (window.location.pathname.startsWith('/en')) {
    router.push('/en/producer')
  } else {
    router.push('/producer')
  }
}
// 已有：硬件产品列表页
function goto_producthard() {
  if (window.location.pathname.startsWith('/en')) {
    router.push('/en/producthard')
  } else {
    router.push('/producthard')
  }
}
// 硬件产品详情页跳转
function goto_productharddetail(id) {
  if (window.location.pathname.startsWith('/en')) {
    router.push(`/en/devicetypedetail?id=${id}`)
  } else {
    router.push(`/devicetypedetail?id=${id}`)
  }
}
// 解决方案详情页跳转
function goto_solution(id) {
  if (window.location.pathname.startsWith('/en')) {
    router.push(`/en/solutiondetail?id=${id}`)
  } else {
    router.push(`/solutiondetail?id=${id}`)
  }
}
// 软件产品详情页跳转
function goto_system(id) {
  if (window.location.pathname.startsWith('/en')) {
    router.push(`/en/productdetail?id=${id}`)
  } else {
    router.push(`/productdetail?id=${id}`)
  }
}
// 人工智能平台
// function goto_ai() {
//   router.push('/ai')
// }
// // 大数据平台
// function goto_bigdata() {
//   router.push('/data')
// }
// // 综合管理平台
// function goto_manage() {
//    router.push('/manage')
// }
// 系统集成平台

//智慧供热平台
//function goto_smartheating() {
//router.push('/smartheating')
//}
//行业案例以及子跳转
function goto_case() {
  if (window.location.pathname.startsWith('/en')) {
    router.push('/en/case')
  } else {
    router.push('/case')
  }
}
//新闻资讯以及子跳转
function goto_news() {
  if (window.location.pathname.startsWith('/en')) {
    router.push('/en/news')
  } else {
    router.push('/news')
  }
}
//关于我们以及子跳转
function goto_about() {
  if (window.location.pathname.startsWith('/en')) {
    router.push('/en/about')
  } else {
    router.push('/about')
  }
}
async function navrender() {
  const appId = window.location.pathname.startsWith('/en') ? 2 : 1
  const pro_res = await getProductList({ appId, current: 1, size: 100 })
  pro_data.value = pro_res.data || []
  const sul_res = await getSolutionList({ appId, current: 1, size: 100 })
  sul_data.value = sul_res.data || []
  const proHard_res = await getDeviceTypeList({ appId, current: 1, size: 100 })
  pro_hard_data.value = proHard_res.data || []
  hardware_data.value = proHard_res.data || []
}

/**
 * 处理语言切换命令
 * @param {string} command - 语言命令 (zh 或 en)
 */
function handleCommand(command) {
  // 获取当前基础域名 (如 "https://example.com")
  const baseUrl = window.location.origin;
  
  // 获取当前路径 (不含域名和查询参数)
  const currentPath = window.location.pathname;

   // 处理中文路径 (zh)
  if (command === 'zh') {
    // 移除路径中的语言段 /en
    const newPath = currentPath.replace(/^\/en(\/|$)/, '$1');
    window.location.href = baseUrl + newPath + window.location.search;
  }
  // 处理英文路径 (en)
  else if (command === 'en') {
    // 如果当前不是英文路径则添加 /en
    if (!currentPath.startsWith('/en')) {
      // 确保路径格式正确 (处理根路径情况)
      const separator = currentPath === '/' ? '' : '/';
      window.location.href = `${baseUrl}/en${separator}${currentPath.substring(1)}${window.location.search}`;
    }
  }
}

// 使用示例：
// handleCommand('zh'); // 访问 https://example.com
// handleCommand('en'); // 访问 https://example.com/en

function getLanguage() {
  // 判断地址是否包含 /en
  if (window.location.pathname.startsWith('/en')) {
    return 'English';
  } else {
    return '中文';
  }
}

</script>

<style scoped>
li {
  list-style: none;
}

.nav-bar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 5em;
  display: flex;
  background-color: #fff;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.nav-box2 {

  margin-right: 00px;
  width: 160px;
  height: 20px;
  /* background-image: url("https://developer.mozilla.org/static/media/language.e4289910782fa8d1c882.svg"); */
}
.nav-phone {
  display: flex;
  align-items: center;
  white-space: nowrap;
  margin-right: 1em;
}
.phone-icon {
  width: 1em;
  height: 1em;
  margin-right: 0.3em;
}
.phone-number {
  font-size: 1.1em;
  font-weight: 600;
  color: #005BAC;
}
.el-dropdown-link {
  display: flex;
  justify-content: space-between;
  height: 20px;
}
.span1 {
  width: 20px;
  height: 20px;
}

.span2 {
  line-height: 20px;
  margin-left: 5px;
  color: #00000A;
  font-weight: 600;
}

.nav-box {
  display: flex;
  justify-content: space-between;
  ;
  width: 60%;
  height: 60%;
  margin: 0 auto;
  align-items: center;
  /* background-color:skyblue; */
  display: flex;
}

.nav-left {
  width: 30%;
}

.nav-left a {
  display: flex;
  align-items: center;
  height: 100%;
}

.nav-left img {
  width: 60%;
  height: 100%;
}

.nav-right {
  width: 65%;
  height: 100%;
  /* background-color: pink; */
}

.right-content ul {
  display: flex;
  width: 100%;
  line-height: 3em;
  justify-content: space-between;
  white-space: nowrap;
  /* background-color: pink; */
}

.right-content ul li {
  padding-left: 0.8em;
  padding-right: 0.8em;
}

.right-content>ul li:hover {
  cursor: pointer;
  color: rgb(22, 126, 255);
}

.dropdown {
  display: flex;
  position: absolute;
  background: white;
  color: black;
  width: 65%;
  left: 28%;
  padding: 10px 0;
  z-index: 1000;
  box-shadow: 0px 0px 6px 0px #ddd;
}

.dropdown_en {
  width: 50%;
  left: 28%;
}
.dropdown2 {
  display: flex;
  position: absolute;
  background: white;
  color: black;
  width: 18%;
  left: 48%;
  padding: 10px 0;
  z-index: 1000;
  box-shadow: 0px 0px 6px 0px #ddd;
}

.dropdown2.has-devices {
  width: 36%;
  left: 40%;
}

.dropdown2 .drop_left {
  width: 100%;
  border-right: none;
}

.dropdown2.has-devices .drop_left {
  width: 50%;
  border-right: 1px solid #eee;
}

.dropdown2 .drop_right {
  width: 50%;
  padding-left: 0.5em;
}

.dropdown2 .drop_right h3 {
  margin-left: 0.5em;
}

.dropdown2 .drop_right ul {
  width: 90%;
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
}

.dropdown2 .drop_right ul li {
  list-style: none;
  width: 100%;
}

.active-type {
  color: rgb(22, 126, 255);
  background-color: #f0f7ff;
}


.drop_left {
  width: 40%;
  margin-left: 0.5em;
  /* margin-left: 1em; */
}
.drop_left_en {
  width: 50%;
  /* margin-left: 1em; */
}


.drop_left h3 {
  margin-left: 0.5em;
}

/* 新增：Products 列两列布局 */
.drop_left > ul {
  width: 95%;
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
}

.drop_left > ul li {
  list-style: none;
  width: 100%;
}

.drop_mid {
  width: 35%;
}

.drop_mid>ul {
  width: 90%;
  display: flex;
  flex-direction: column;
}

.drop_mid>ul li {
  list-style: none;
  width: 100%;
}

.drop_mid h3 {
  margin-left: 0.5em;
}

/* 调整：解决方案列宽度 */
.drop_right {
  width: 35%;
}
.drop_right_en {
  width: 50%;
}

.drop_right>ul {
  width: 90%;
  display: flex;
  flex-direction: column;
}

.drop_right>ul li {
  list-style: none;
  width: 100%;
}

.drop_right h3 {
  margin-left: 0.5em;
}

.mobile-toggle {
  font-size: 1.5em;
  cursor: pointer;
  display: none;
}

.mobile-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: none;
  z-index: 1001;
}

.mobile-dropdown ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.mobile-dropdown li {
  padding: 0.5em 1em;
  height: 3em;
  line-height: 3em;
  cursor: pointer;
}

.mobile-dropdown li:hover {
  background-color: #f5f5f5;
}

/* 添加到 style 部分的末尾 */
.el-dialog {
  padding: 0 !important;

}
/* 覆盖 Element Plus 对话框样式，去掉白边 */
.vidaodialog {
  --el-dialog-padding-primary: 0;
  padding: 0 !important;
}
:deep(.el-dialog) {
  padding: 0 !important;
  background-color: transparent;
  box-shadow: none;

  
}

:deep(.el-dialog__header) {
height: 0;  
padding-bottom: 0;
}


.vidaodialog .el-dialog__body {
  padding: 0;
}

.vidaodialog .el-dialog__header {
  padding: 0;
  margin: 0;
  display: none; /* 隐藏头部 */
}

.vidaodialog .el-dialog__footer {
  padding: 10px;
  margin: 0;
  text-align: center;
}

/* 确保视频容器没有内边距 */
.vidaodialog > div:first-child {
  padding: 0;
  margin: 0;
}
.dialog-footer {
  display: flex;
  justify-content: center;
}

/* 移动端适配 */
@media (max-width: 1024px) {
  .vidaodialog {
    --el-dialog-width: 95% !important;
    margin: 10px;
  }
  
  .vidaodialog .el-dialog__body {
    padding: 0;
  }
}

@media (max-width: 1024px) {
  .mobile-toggle {
    display: block;
    cursor: pointer;
    position: absolute;
    font-size: 2em;
    right: 0.5em;
  }
  .nav-box2 {
    margin-right: 0.5em;
  }

  .right-content {
    display: none;
  }

  .mobile-dropdown {
    display: block;
  }

  .nav-left img {
    width: 100%;
  }

  .nav-box {
    width: 100%;
  }
}

.close-btn {
  position: absolute;
  top: -30px;
  right: -30px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.7);
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.close-btn:hover {
  background-color: rgba(0, 0, 0, 0.9);
  transform: scale(1.1);
}

.close-icon {
  line-height: 1;
  margin-top: -2px;
  font-weight: bold;
  font-size: 2rem;
}

/* 确保对话框相对定位，让关闭按钮可以绝对定位 */
.vidaodialog {
  position: relative;
}

/* 移动端适配 */
@media (max-width: 1024px) {
  .close-btn {
    top: -10px;
    right: -10px;
    width: 35px;
    height: 35px;
    font-size: 20px;
  }
}
</style>
